<p
  class="styled-primary-text"
  [ngStyle]="{
    fontSize: fontSize,
    marginTop: mt,
    marginBottom: mb,
    '--line-height': lineHeight,
    '--line-height-mobile': lineHeightMobile
  }"
>
  <ng-content></ng-content>
</p>